import { fetchData } from "./testUpdateProgress";
import uploadFile from "../uploadFiles";

export const launchScriptsFromQueue = async (
  queues,
  appContext,
  setScriptsContext
) => {
  const uploadPromises = queues.filesQueue.map(
    (fileObj, index) =>
      new Promise((resolve, reject) => {
        uploadFilesUpdateContext(
          setScriptsContext,
          "in progress",
          0.25,
          fileObj.name,
          false,
          index + 1,
          queues.filesQueue.length
        );

        if (!fileObj.isUploadedOnBackend && fileObj.status !== "Skipped") {
          uploadFile(
            fileObj.file,
            fileObj.backEndFileName,
            appContext.dataModelId
          )
            .then(() => {
              uploadFilesUpdateContext(
                setScriptsContext,
                "complete",
                1,
                fileObj.name,
                false,
                index + 1,
                queues.filesQueue.length
              );
              resolve(); // Resolve the promise when the upload is complete
            })
            .catch((error) => {
              reject(error); // Reject the promise if an error occurs during upload
            });
        } else {
          // Resolve immediately if no upload is needed
          uploadFilesUpdateContext(
            setScriptsContext,
            "complete",
            1,
            fileObj.name,
            false,
            index + 1,
            queues.filesQueue.length
          );
          resolve();
        }
      })
  );

  try {
    // Wait for all uploads to complete
    await Promise.all(uploadPromises);

    // After uploads complete, proceed with launching scripts
    for (const [index, scriptConfigObj] of queues.scriptsQueue.entries()) {
      if (!scriptConfigObj.skipped) {
        const scriptConfigObjWithParams = buildRequestParams(
          appContext,
          scriptConfigObj
        );
        await fetchData(
          (updatedProgress) => {
            updateScriptsContext(
              updatedProgress,
              setScriptsContext,
              scriptConfigObjWithParams.name,
              index + 1,
              queues.scriptsQueue.length
            );
          },
          scriptConfigObjWithParams.endpoint,
          scriptConfigObjWithParams.filledRequestParams
        );
      }
    }
  } catch (error) {
    console.error("An error occurred", error);
  }
};

//Original Function to replace when we don't need to skip scripts

// export const launchScriptsFromQueue = async (
//   queues,
//   appContext,
//   setScriptsContext
// ) => {
//   // Create a promise for each file upload
//   const uploadPromises = queues.filesQueue.map((fileObj) =>
//     uploadFile(fileObj.file, fileObj.backEndFileName)
//   );

//   try {
//     // Wait for all uploads to complete
//     await Promise.all(uploadPromises);

//     // Continue with the rest of your function
//     for (const scriptConfigObj of queues.scriptsQueue) {
//       // assuming scriptObj.endpoint is the endpoint for each scriptObj
//       const scriptConfigObjWithParams = buildRequestParams(
//         appContext,
//         scriptConfigObj
//       );
//       await fetchData(
//         (updatedProgress) => {
//           console.log(updatedProgress);
//           updateScriptsContext(
//             updatedProgress,
//             setScriptsContext,
//             scriptConfigObjWithParams.name
//           );
//           // Update the UI with the new progress data here
//         },
//         scriptConfigObjWithParams.endpoint,
//         scriptConfigObjWithParams.filledRequestParams
//       );
//     }
//   } catch (error) {
//     console.error("An error occurred while uploading the files", error);
//   }
// };

export const buildRequestParams = (appContext, scriptConfigObj) => {
  const filledRequestParams = {};

  scriptConfigObj.requiredQueryParams.forEach((param) => {
    if (appContext[param] !== undefined) {
      filledRequestParams[param] = appContext[param];
    }
  });

  return {
    ...scriptConfigObj,
    filledRequestParams,
  };
};

function updateScriptsContext(
  data,
  setScriptsContext,
  scriptName,
  numberInQueue,
  queueLength
) {
  setScriptsContext((prevState) => ({
    ...prevState,
    isRunning: data.status !== "failed" && data.status !== "complete",
    scriptRunningError: data.error || false,
    scriptRunningName: scriptName || prevState.scriptRunningName,
    scriptRunningCurrentStep:
      data.step_for_user || prevState.scriptRunningCurrentStep,
    scriptRunningProgress: data.progress || 0,
    status: data.status || "not started",
    action: "Building",
    numberInQueue: numberInQueue,
    queueLength: queueLength,
    exception: data.exception || "",
    message: data.step_for_user || "",
  }));
}

const uploadFilesUpdateContext = (
  setScriptsContext,
  status,
  progress,
  fileUploadingName,
  fileUploadingError,
  numberInQueue,
  queueLength
) => {
  setScriptsContext((prevState) => ({
    ...prevState,
    isRunning: status !== "failed" && status !== "complete",
    scriptRunningError: fileUploadingError || true,
    scriptRunningName: fileUploadingName || "Unknown",
    status: status,
    scriptRunningProgress: progress || 0,
    action: "Uploading",
    numberInQueue: numberInQueue || 0,
    queueLength: queueLength || 0,
  }));
};

// export const fetchData = async (onProgress, endpoint, param1, param2) => {
//   try {
//     const url = new URL(`${devApiUrl}/${endpoint}`);
//     url.searchParams.append('param1', param1);
//     url.searchParams.append('param2', param2);

//     const eventSource = new EventSource(url);

//     eventSource.onmessage = function (event) {
//       const data = JSON.parse(event.data);

//       if (data.status === "progress") {
//         onProgress(data, param1, param2);
//         console.log(data);
//       } else if (data.type === "error") {
//         console.error("An error occurred:", data);
//         eventSource.close(); // Close the connection after receiving an error
//       } else if (data.status === "completed") {
//         eventSource.close(); // Close the connection after receiving the final data
//       }
//     };

//     eventSource.onerror = function (err) {
//       console.error("EventSource failed:", err);
//       eventSource.close();
//     };

//     return () => {
//       eventSource.close();
//     };
//   } catch (error) {
//     console.error("Error fetching progress:", error);
//   }
// };
